
const userManagementRouteList = {
    addOrEdit:"add-or-edit",
    userPrivilage:"user-privilege",
    menuSetting:"menu-settings",
    LogHistory: "log-history",
    userLog: "user-log",
    menuRearragne:"menu-rearrange"
}

export default userManagementRouteList
